import { render, staticRenderFns } from "./_holderScrap_Master.vue?vue&type=template&id=56213476&scoped=true&"
import script from "./_holderScrap_Master.vue?vue&type=script&lang=js&"
export * from "./_holderScrap_Master.vue?vue&type=script&lang=js&"
import style0 from "./_holderScrap_Master.vue?vue&type=style&index=0&id=56213476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56213476",
  null
  
)

export default component.exports